import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
import { getAuthentication, isReportIssuer } from '../../api/auth'
import { getFrontPageBigNumbers } from '../../dummy-data/DUMMYDATA'
import Loading from '../Loading'
import BigNumbers from '../shared/BigNumbers'
// import BigNumbersV2 from '../shared/BigNumbersV2'
import Logo from '../Logo'
// import ReactLoading from 'react-loading'


import { ReactComponent as SiemensLogo } from '../../static/logos/sie-logo-petrol-rgb.svg'
import { ReactComponent as IPLogo } from '../../static/logos/ip.svg'
import moment from 'moment'
import { capitalize } from '../../utils/utils'

export default class Frontpage extends Component {

  constructor(props) {
    super(props)

    this.state = {
      data: undefined
    }
  }


  componentDidMount() {
    getFrontPageBigNumbers(isReportIssuer(), getAuthentication().entity).then(
      res => this.setState({data: res})
    ).catch(err => console.log(err))

  }

  render() {

    // const renderLogo = () => {
    //   return (
    //     <div className='section' style={{position: 'relative', textAlign: 'center'}}>

    //       <img src={'logo.svg'} style={{height: '20vh'}}/>

    //       <p style={{
    //         position: 'absolute',
    //         bottom: '20%',
    //         left: '50%',
    //         transform: 'translate(-50%, 0)',
    //         fontWeight: 'bold',
    //         color: 'gray'            
    //       }}>
    //       By Siemens Mobility Portugal
    //       </p>
    //     </div>

    //   )
    // }

    const renderBigNumbers = () => {
      if (!this.state.data) {
        return <Loading />
      }


      let title = `Resumo:
                   ${capitalize(moment(this.state.data.fromDt).format('MMM-YYYY'))} a
                   ${capitalize(moment(this.state.data.toDt).format('MMM-YYYY'))}`

      return <BigNumbers 
        records={this.state.data.readings}
        title={title}
        operatorName={getAuthentication().entity}
      />
    }

    
    return (
      <div className='container' style={{
      }}>

        <Logo />
        {/* {renderLogo()} */}

        <p className='has-text-warning has-text-centered has-text-weight-bold mb-6'>
          Versão de Demonstração
        </p>

        <section className='container'>
          {renderBigNumbers()}
        </section>


        <div className='container mb-3 mt-6' style={{width: '100vw'}}>
          <div className='columns has-text-centered is-vcentered'>
            <div className='column is-3'>
              <SiemensLogo width="150px" height="20"/>           
            </div>
            <div className='column is-6'>
              <p className='subtitle is-size-6 has-text-weight-bold'>e.coPortal By Siemens Mobility Portugal © {moment().year()}</p>
            </div>
            <div className='column is-3'>
              <IPLogo width="150px"/>
            </div>
          </div>
        </div>

      </div>
    )
  }
}
